export enum Claim {
    UserId = 'api.4itruvian.nl.userId',
    ActiveTenantId = 'api.4itruvian.nl.activeTenantId',
    ActiveTenantUrl = 'api.4itruvian.nl.activeTenantUrl',
    UserName = 'api.4itruvian.nl.userName',
    Roles = 'api.4itruvian.nl.role',
    Rights = 'api.4itruvian.nl.right',
}
